export default angular.module('radioSlider', [])
    /**
     * @ngdoc controller
     * @name radioSlider.controller:radioSliderController
     * @description
     * Controller for managing the current state of the slider.
     * Responsible for positioning the active slider element.
     */
    // @ngInject
    .controller('radioSliderController', function ($scope, $log) {
        var $container = null;
        var $checked = null;
        var $slider = angular.element('<div class="form-active-slider"></div>');
        // Toggle the state (via class) of the active slider which will be
        // Inactive when no radio item is selected
        function toggleSlider(override) {
            $slider.toggleClass('form-active-slider--active', override);
        }
        // Using inline CSS toggle the position of the active slider
        // Using translateX to offset from the left
        function updateSliderPosition(checkedInput) {
            let offset = 0;
            let translate;

            const mobileBreakpoint = 768
            if (!$container || !$slider) {
                return;
            }
            if (checkedInput !== null) {
                let containerOffset;
                let inputOffset;
                var inputLabel = checkedInput.next();
                if (!inputLabel.length) {
                    $log.error('ERROR: input label is not beside radio input');
                    return;
                }

                const isMobile = window.innerWidth < mobileBreakpoint

                // The idea is here is to switch the translate to Y when it's vertical stacked and X axis when it's horizontal.
                if (isMobile) {
                    containerOffset = $container[0].getBoundingClientRect().top;
                    inputOffset = inputLabel[0].getBoundingClientRect().top;
                    offset = 1 + Math.ceil(inputOffset - containerOffset);
                    translate = ['translateY(', offset, 'px)'].join('');
                } else {
                    containerOffset = $container[0].getBoundingClientRect().left;
                    inputOffset = inputLabel[0].getBoundingClientRect().left;
                    offset = 1 + Math.ceil(inputOffset - containerOffset);
                    translate = ['translateX(', offset, 'px)'].join('');
                }
            }

            $slider.css({ 'transform': translate });
        }
        // Set the container for this controller instance where
        // The slider will be positioned within
        this.setContainer = function setContainer(element) {
            $container = element;
            $container.append($slider);
            angular.element(window).on('resize', function () {
                updateSliderPosition($checked);
            });
        };
        // Update the current checked element to move the slider
        // Along the container view
        this.setCheckedElement = function setCheckedElement(element) {
            $checked = element;
            toggleSlider($checked !== null);
            updateSliderPosition($checked);
        };
    })
    /**
     * @ngdoc directive
     * @name radioSlider.directive:radioSlider
     * @restrict A
     * @description
     * Creates a controller instance and sets containing element
     */
    // @ngInject
    .directive('radioSlider', function () {
        return {
            controller: 'radioSliderController',
            restrict: 'A',
            link: function ($scope, $element, attrs, controller) {
                controller.setContainer($element);
            }
        };
    })
    /**
     * @ngdoc directive
     * @name radioSlider.directive:radioSliderItem
     * @restrict A
     * @description
     * Each radio item can trigger an update of the checked element
     */
    // @ngInject
    .directive('radioSliderItem', function () {
        return {
            require: '^radioSlider',
            restrict: 'A',
            link: function ($scope, $element, attrs, controller) {
                $scope.$watch(attrs.ngModel, function (value) {
                    if (value === attrs.value) {
                        controller.setCheckedElement($element);
                    }
                });
            }
        };
    });
